/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'expenseCategories/placeholder1': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
		data: '<path d="M3.24,7.29l8.52,4.63a.51.51,0,0,0,.48,0l8.52-4.63A.44.44,0,0,0,21,6.7a.45.45,0,0,0-.25-.22L12.19,3a.5.5,0,0,0-.38,0L3.29,6.48A.44.44,0,0,0,3,7,.45.45,0,0,0,3.24,7.29Z"/><path d="M20.71,10.66l-1.83-.78-6.64,3.61a.51.51,0,0,1-.48,0L5.12,9.88l-1.83.78a.48.48,0,0,0,0,.85l8.52,4.9a.46.46,0,0,0,.48,0l8.52-4.9a.48.48,0,0,0,.13-.67A.47.47,0,0,0,20.71,10.66Z"/><path d="M20.71,15.1l-1.56-.68-6.91,3.76a.51.51,0,0,1-.48,0L4.85,14.42l-1.56.68a.49.49,0,0,0-.21.66.53.53,0,0,0,.21.21l8.52,5a.51.51,0,0,0,.48,0l8.52-5a.49.49,0,0,0,.14-.68A.5.5,0,0,0,20.71,15.1Z"/>'
  }
})
